import { Account } from '@ecm/data/Account'
import { Addon } from '@ecm/data/Addon'
import { Address, addressToString } from '@ecm/data/Address'
import { Billing } from '@ecm/data/Billing'
import { getCountryLabel } from '@ecm/data/Country'
import { Coupon } from '@ecm/data/Coupon'
import { CustomerDo, OrderDo, ProductDo } from '@ecm/data/Ecommerce'
import { getSha256Hash } from '@ecm/data/Hash'
import { OrderEstimate } from '@ecm/data/Order'
import { Plan } from '@ecm/data/Plan'
import { getStateLabel } from '@ecm/data/State'

const DEFAULT_ADDRESS_PRICE = 30
const DEFAULT_ADDRESS_ID = 'Beaverton_OR_STR_Gemini'

export const mapCustomerDo = (a: Account, b?: Billing): CustomerDo => ({
  customerCity: b?.city ?? null,
  customerCountry: b?.countryCode ? getCountryLabel(b.countryCode) ?? 'N/A' : null,
  customerEmail: a.email ? getSha256Hash(a.email) : null,
  customerState: b?.stateCode ? getStateLabel(b.stateCode) ?? 'N/A' : null,
})

export const mapOrderDo = (oe: OrderEstimate, b?: Billing, c?: Coupon): OrderDo => ({
  orderCoupon: c?.description ?? null,
  orderDiscount: Number(
    (oe.next_estimate.total_in_cents / 100 - oe.initial_estimate.total_in_cents / 100).toFixed(2)
  ),
  orderId: b?.uuid ?? null,
  orderTax: Number((oe.next_estimate.total_tax_in_cents / 100).toFixed(2)),
  orderValue: Number((oe.next_estimate.total_in_cents / 100).toFixed(2)),
  orderValueToPay: Number((oe.initial_estimate.total_in_cents / 100).toFixed(2)),
})

export const mapProductDo = (
  plan: Plan,
  address?: Address,
  defaultPrice?: boolean,
  addon?: Addon
): ProductDo => ({
  productCategory: plan.name,
  productCategory2: address ? address.state : addon ? 'Addons' : null,
  productCategory3: address ? address.city : null,
  productId: address ? address.slug : addon ? addon.slug : null,
  productList: address
    ? address.slug === DEFAULT_ADDRESS_ID
      ? 'Default Address'
      : address.isFeatured
      ? 'Featured Addresses'
      : 'All Addresses'
    : addon
    ? 'Addon'
    : null,
  productName: address ? addressToString(address) : addon ? `${addon.label} Addon` : null,
  productPrice: defaultPrice ? DEFAULT_ADDRESS_PRICE : addon ? addon.price : plan.price,
})
